import { createEvent, createStore, restore, sample } from 'effector'

import { toPath } from '../../features/router'
import { Session, setAccessToken } from '../../features/session'
import { ClientError, fx, mapResponseError, path } from '../../libs'
import { LoginByEmail } from './types'
import { redirectPath, clearRedirectPath } from '../../features/session/model'
import { TwoFactorAuthenticationFirst } from '../../features/session/types'
import { initUserProfileFx } from '../../features/user'

export const mounted = createEvent()

export const submitForm = createEvent<LoginByEmail>()

export const setQRCodeData = createEvent<{
  qrCode: string
  id: string
} | null>()
export const $qrCodeData = restore(setQRCodeData, null)

export const loginByEmail = fx<
  LoginByEmail,
  Partial<Session & TwoFactorAuthenticationFirst>
>({
  method: 'POST',
  url: '/auth/get_token',
})

sample({
  clock: submitForm,
  fn: ({ username, password, authCode }) => {
    return {
      body: {
        username,
        password,
        authCode,
      },
    }
  },
  target: loginByEmail,
})

sample({
  clock: loginByEmail.doneData,
  fn: (doneData) => {
    if (!doneData.body.qrCodeData) {
      return doneData.body.token as string
    }
    return ''
  },
  target: setAccessToken,
})

sample({
  clock: loginByEmail.doneData,
  fn: (doneData) => {
    if (doneData.body.qrCodeData) {
      return {
        qrCode: doneData.body.qrCodeData as string,
        id: doneData.body.id as string,
      }
    }
    return null
  },
  target: setQRCodeData,
})

sample({
  clock: loginByEmail.doneData,
  filter: (doneData) => !doneData.body.qrCodeData,
  fn: () => ({ force: true }),
  target: initUserProfileFx,
})

// if login by email done redirect to dashboard

sample({
  clock: loginByEmail.done,
  source: redirectPath,
  filter: (_, item) => !Boolean(item.result.body.qrCodeData),
  fn: (savedPath) => savedPath || path.dashboard(),
  target: toPath,
})

sample({
  clock: loginByEmail.done,
  filter: (item) => !Boolean(item.result.body.qrCodeData),
  target: clearRedirectPath,
})

// handle errors

export const $error = createStore<ClientError<LoginByEmail> | null>(null)

$error
  .on(loginByEmail.failData, (_, failData) =>
    mapResponseError<LoginByEmail>(failData.body),
  )
  .reset([mounted, submitForm])
